var vhcProductGallerySliders = document.querySelectorAll('.wp-block-vhc-product-gallery .swiper');

vhcProductGallerySliders.forEach(function(slider) {
    if (slider.querySelector('.swiper-wrapper')) {
        var swiper = new Swiper(slider, {
            slidesPerView: slider.dataset.mobileSlideCount, 
            spaceBetween: 5, 
            breakpoints: {
                600: {
                    slidesPerView: slider.dataset.desktopSlideCount, 
                    spaceBetween: 5,
                },
            },
            navigation: {
                nextEl: document.querySelector(".swiper-button-next"),
                prevEl: document.querySelector(".swiper-button-prev"),
            },
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    // Get the focus image element
    const focusImage = document.querySelector('.focus-image img');

    // Get all slide images
    const slideImages = document.querySelectorAll('.swiper-slide img');

    // Function to set the active slide
    function setActiveSlide(slideImage) {
        // Remove active class from all slides
        slideImages.forEach(function(img) {
            img.parentElement.classList.remove('active');
        });

        // Add active class to the clicked slide
        slideImage.parentElement.classList.add('active');

        // Replace the focus image's src and alt attributes with the clicked image's attributes
        focusImage.src = slideImage.src;
        focusImage.alt = slideImage.alt;
    }

    // Set the first slide as active by default
    if (slideImages.length > 0) {
        setActiveSlide(slideImages[0]);
    }

    // Add a click event listener to each slide image
    slideImages.forEach(function(slideImage) {
        slideImage.addEventListener('click', function() {
            setActiveSlide(this);
        });
    });
});
